<template>
  <div class="home">
    <head-com></head-com>
    <div class="main">
      <div class="cont bs">
        <h3 class="title">培训记录</h3>
        <div class="tabs">
          <el-form :inline="true" :model="form" class="demo-form-inline">
            <el-form-item>
              <el-select
                v-model="form.postId"
                placeholder="请选择专业"
                size="small"
                clearable
                @change="specialChange"
              >
                <el-option
                  v-for="(item,i) in specialList"
                  :key="i"
                  :label="item.postName"
                  :value="item.postId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="form.overStatus" placeholder="请选择学习状态" size="small" clearable>
                <el-option label="待学习" value="0"></el-option>
                <el-option label="已学完" value="1"></el-option>
                <el-option label="学习中" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="onSearch">查询</el-button>
            </el-form-item>
          </el-form>
          <el-table
            :data="tableData"
            border
            max-height="460"
            :cell-style="cellStyle"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
            highlight-current-row
            :header-cell-style="{background:'#dde9fc',color:'#606266'}"
          >
            <el-table-column type="index" fixed="left" width="50" label="序号"></el-table-column>
            <el-table-column prop="courseName" label="课程" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="postName" label="专业" min-width="120"></el-table-column>
            <el-table-column prop="regDate" label="报名时间" width="120" show-overflow-tooltip></el-table-column>
            <el-table-column
              prop="overStatus"
              label="学习状态"
              :formatter="studyFormat"
              min-width="100"
            ></el-table-column>
            <el-table-column prop="courseTotalHours" label="总学时" min-width="80"></el-table-column>
            <el-table-column prop="finishedHourse" label="已完成学时" min-width="100"></el-table-column>
            <!-- <el-table-column prop="sex" label="性别" min-width="80"></el-table-column>
            <el-table-column prop="idCard" label="身份证号" min-width="200"></el-table-column>-->
            <!-- <el-table-column prop="address" label="手机号" min-width="150"></el-table-column> -->
            <!-- <el-table-column prop="1" label="所属企业" min-width="80"></el-table-column>
            <el-table-column prop="2" label="专业" min-width="80"></el-table-column>-->
            <!-- <el-table-column prop="lastModifyDate" label="最近学习时间" min-width="100"></el-table-column> -->
            <el-table-column label="学习进度" min-width="150">
              <template slot-scope="scope">
                <el-progress :percentage="scope.row.progress"></el-progress>
              </template>
            </el-table-column>
            <el-table-column
              prop="approvalStatus"
              label="审核状态"
              min-width="80"
              :formatter="stateFormat"
            ></el-table-column>
            <el-table-column label="操作" width="220" fixed="right">
              <template slot-scope="scope">
                <el-button
                        style="margin-bottom: 10px"
                  @click="auditCommit(scope.row)"
                  type="success"
                  size="mini"
                  v-if="scope.row.approvalStatus == 1"
                >提交审核</el-button>
                <el-button @click="handleClick(scope.row)" type="primary" size="mini">查看学习照片</el-button>
              <!--  <el-button @click="downloadTrainingProve(scope.row)" :disabled="scope.row.approvalStatus==1" type="primary" size="mini">证书下载</el-button>-->
              </template>
            </el-table-column>
          </el-table>
          <pagination
            :currentPage="currentPage"
            :total="total"
            :limit="limit"
            ref="page"
            @handleCurrentChange="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
          />
        </div>
      </div>
      <!-- 查看学习照片 -->
      <el-dialog title="查看学习照片" :visible.sync="detailDialog" width="80%" center top="9vh">
        <div class="imgs">
          <div class="case">
            <span class="tag">证件照：</span>
            <img :src="imgInfo.empHeadportrait" alt />
            <div v-if="!imgInfo.empHeadportrait" class="inline not">暂无证件照</div>
          </div>
          <div class="case">
            <span class="tag">身份证人像面：</span>
            <img :src="imgInfo.empIdcardFront" alt />
            <div v-if="!imgInfo.empIdcardFront" class="inline not">暂无身份证人像面</div>
          </div>
          <div class="case">
            <span class="tag">身份证国徽面：</span>
            <img :src="imgInfo.empIdcardNegative" alt />
            <div v-if="!imgInfo.empIdcardNegative" class="inline not">暂无身份证国徽面</div>
          </div>
        </div>
        <el-table
          :data="photoInfo"
          border
          max-height="430"
          style="width: 100%"
          highlight-current-row
          :header-cell-style="{background:'#dde9fc',color:'#606266'}"
        >
          <el-table-column type="index" width="50" label="序号"></el-table-column>
          <!-- <el-table-column prop="courseName" label="课程名称" min-width="120"></el-table-column> -->
          <!-- <el-table-column prop="ccName" label="章节名称" min-width="120"></el-table-column> -->
          <el-table-column tree-props="{children: 'children'}" label="章节名称" min-width="120">
            <template slot-scope="scope">
              <span>{{scope.row.sectionName}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="courseOver" :formatter="finishedFormat" label="学习状态" width="120"></el-table-column>
          <el-table-column prop="courseStudyEnd" label="完成时间" width="180"></el-table-column>
          <el-table-column label="实时拍摄照片" width="240">
            <template slot-scope="scope" v-if="scope.row.photoList.length != 0">
               <el-image 
                v-for="(item,index) in scope.row.photoList" 
                :key="index" 
                :src="item" 
                style="width: 60px; height: 60px;margin:0 5px;" 
                :preview-src-list="getImgList(scope.row.photoList, index)" />
              <!-- <img class="small" v-for="(item,index ) in scope.row.photoList" :key="index" :src="item.photoUrl" alt /> -->
            </template>
          </el-table-column>
          <el-table-column label="审核状态" width="160">
            <template slot-scope="scope">
              <el-tooltip placement="top" :disabled="scope.row.invalid !== 1 ">
                <div slot="content">{{scope.row.invalidComment}}</div>
                <el-button
                  type="text"
                  v-if="scope.row.state == '通过'"
                  style="color:#67C23A"
                >{{scope.row.state}}</el-button>
                <el-button
                  type="text"
                  v-else-if="scope.row.state == '不通过'"
                  style="color:#F56C6C"
                >{{scope.row.state}}</el-button>
                <el-button type="text" v-else style="color:#409EFF">{{scope.row.state}}</el-button>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="invalidComment" label="审核意见" min-width="100" show-overflow-tooltip></el-table-column>
        </el-table>
      </el-dialog>
    </div>
    <footer-com></footer-com>
  </div>
</template>

<script>
import HeadCom from "@/components/Header.vue";
import FooterCom from "@/components/Footer.vue";
import http from "../api/module";
import pagination from "../components/pagination";
import { courseURL } from "../api/baseUrl";

export default {
  name: "personRecord",
  components: {
    HeadCom,
    pagination,
    FooterCom
  },
  data() {
    return {
      loading: true,
      currentPage: 1, // 当前页
      limit: 10, // 每页显示数量
      total: 0, // 总条目数
      specialList: JSON.parse(sessionStorage.getItem("specialList")),
      form: {},
      detailDialog: false,
      tableData: [],
      photoInfo: [],
      imgInfo: {}
    };
  },

  mounted() {
    this.getPostList();
    this.getInfo();
  },
  methods: {
    // 当前页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getInfo();
    },
    // 每页数
    handleSizeChange(val) {
      this.limit = val;
      this.currentPage = 1;
      this.getInfo();
    },
    specialChange(val) {
      console.log(val);
      this.postId = val;
    },
    onSearch() {
      this.currentPage = 1;
      this.$refs.page.init();
      this.getInfo();
    },
    // 获取注册专业
    getPostList() {
      http
        .getSpecial({
          entpId: sessionStorage.getItem("entpId")
        })
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            this.specialList = data.data.data;
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {
          this.$message.error({
            duration: 1000,
            message: "请求失败,请联系管理员!"
          });
        });
    },
    getInfo() {
      http
        .trainRecord({
          pageNum: this.currentPage,
          pageSize: this.limit,
          postId: this.postId,
          overStatus: this.form.overStatus
        })
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            this.loading = false;
            this.total = data.data.total;
            this.tableData = data.data.data.map(item => {
              var finish = item.finishedHourse || 0;
              var total = item.courseTotalHours || 0;
              item.progress = ((finish / total) * 100).toFixed(0) * 1;
              return item;
            });
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {
          this.$message.error({
            duration: 1000,
            message: "请求失败，请联系管理员！"
          });
        });
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 8) {
        return row.approvalStatus == "0"
          ? "color:#67C23A"
          : row.approvalStatus == "1"
          ? "color:#F56C6C"
          : "color:#409EFF";
      } else {
        return "";
      }
    },
    studyFormat(row, column) {
      var state = row.overStatus;
      return state == "1" ? "已学完" : state == "2" ? "学习中" : "待学习";
    },
    stateFormat(row) {
      var approvalStatus = row.approvalStatus;
      return approvalStatus == "0"
        ? "通过"
        : approvalStatus == "1"
        ? "不通过"
        : "待审核";
    },
    finishedFormat(row, column) {
      var state = row.courseOver;
      return state == "1" ? "已学完" : state == "2" ? "学习中" : "待学习";
    },
    auditCommit(row) {
      this.btrId = row.btrId;

      this.$confirm('确定提交审核吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        http.userSaveTrainingRecords({
                  recordId: this.btrId
                })
                .then(data => {
                  if (data.data.code == "200" || data.data.success == true) {
                    this.$message({
                      type: "success",
                      duration: 1500,
                      message: "操作成功!"
                    });
                    this.getInfo();
                  } else {
                    this.$message.error({
                      duration: 1000,
                      message: data.data.message
                    });
                  }
                })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消审核通过'
        });

      });
    },
    handleClick(row) {
      this.detailDialog = true;
      var regId = row.regId;
      var courseId = row.courseId;
      var empId = row.empId;
      this.employeeDetail(empId);
      this.getPhotoList(regId, courseId, empId);
    },
    downloadTrainingProve(row){//获取证书
      var obj=row;
      var url = `${courseURL}/trainingRecord/downloadTrainingProve?tokenId=${sessionStorage.getItem("token")}
      &btrId=${obj.btrId}`;
      window.location.href = url;
      /*http
              .downloadTrainingProve({
                btrId: obj.btrId
              })
              .then(data => {
              })
              .catch(error => {});*/
    },
    // 根据用户id获取用户信息
    employeeDetail(empId) {
      http
        .employeeDetail({
          empId: empId
        })
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            this.imgInfo = data.data.data;
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {});
    },
    getPhotoList(regId, courseId, empId) {
      http
        .getPhoto({
          regId: regId,
          courseId: courseId,
          empId: empId
        })
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            this.photoInfo = data.data.data.map(item => {
              var invalid = item.invalid; // 审核状态
              item.state =
                invalid === 0 ? "通过" : invalid === 1 ? "不通过" : "待审核";
              var invalidComment = item.invalidComment;
              // var sysUpdatetime = item.sysUpdatetime; // 完成时间
              // var courseOver = item.courseOver;
              // if (courseOver == 1) {
              //   item.sysUpdatetime = sysUpdatetime;
              // } else {
              //   item.sysUpdatetime = "";
              // }
              var cateName = item.cateName;
              var ccName = item.ccName;
              var photoList = item.photoList;
              item.sectionName = cateName + "——" + ccName;
              if (photoList.length) {
                // item.photoUrl = photoList[0].photoUrl;
                // item.createdate = photoList[0].createdate;
              }
              return item;
            });
            for(let i =0;i<this.photoInfo.length;i++){
              if(this.photoInfo[i].photoList.length){
                for(let j =0;j<this.photoInfo[i].photoList.length;j++){
                this.photoInfo[i].photoList[j]=this.photoInfo[i].photoList[j].photoUrl
                }
              }
            }
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {});
    },
    //查看图片
    getImgList(photoList, index) {
      let arr = []
      if (photoList.length == 1) {
        arr.push(photoList[0])
      } else if (photoList.length == 0)  {
        return arr;
      } else {
      for(let i = 0;i < photoList.length;i++){
          arr.push(photoList[i+index])
          if(i+index >= photoList.length-1){
          index = 0-(i+1);
          }
      }
      }
      return arr;
    },
  }
};
</script>
<style lang="less" scoped>
/deep/.el-form-item {
  margin-bottom: 20px;
}
.cont {
  border-radius: 6px;
  width: 100%;
  margin: 20px 0;
  background: #ffffff;
  .title {
    font-size: 18px;
    line-height: 60px;
    border-bottom: 1px solid #ddd;
    padding: 0 20px;
    font-weight: normal;
  }
}
.tabs {
  padding: 20px;
}
.small {
  display: inline-block;
  height: 100px;
  width: auto;
}
.imgs {
  width: 100%;
  padding: 0 100px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-around;
  .tag {
    font-size: 16px;
    display: inline-block;
    vertical-align: top;
  }
  img {
    max-height: 140px;
    width: auto;
  }
  .not {
    margin-left: 10px;
    color: rgb(136, 133, 133);
  }
}
</style>
